<script lang="ts" setup>
import { OrderStopType } from "@/constants/order";
import { computed } from "vue";
import { useDateTime } from "@/composables";

const { dateTZ } = useDateTime();

const props = defineProps<{
  timeTo: string | null;
  checkInTime: string | null;
  loadUnloadTime: string | null;
  stopType: OrderStopType;
  checkOutTime: string | null;
  timezone: string | null;
  timerSize?: number;
}>();

const isPickUp = computed(() => {
  return props.stopType === OrderStopType.pickup;
});

const isDelivery = computed(() => {
  return props.stopType === OrderStopType.delivery;
});
</script>

<template>
  <div class="d-flex">
    <div class="mr-2">
      <div v-if="timeTo" class="mb-1">Appointment:</div>
      <div v-if="checkInTime" class="mb-1">Checked in:</div>
      <div v-if="loadUnloadTime && isPickUp" class="mb-1">Loaded:</div>
      <div v-if="loadUnloadTime && isDelivery" class="mb-1">Unloaded:</div>
      <div v-if="checkOutTime">Completed:</div>
    </div>
    <div>
      <div v-if="timeTo" class="mb-1" data-qa="route-stops-appointment">
        {{ dateTZ(timeTo, timezone) }}
      </div>
      <div v-if="checkInTime" class="mb-1" data-qa="route-stops-checked-in">
        {{ dateTZ(checkInTime, timezone) }}
      </div>
      <div v-if="loadUnloadTime" class="mb-1" data-qa="route-stops-loaded">
        {{ dateTZ(loadUnloadTime, timezone) }}
      </div>
      <div v-if="checkOutTime" data-qa="route-stops-completed">
        {{ dateTZ(checkOutTime, timezone) }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
